import React from 'react';

const Landing = () => (
  <div>
    <h1>Landing Page</h1>
  </div>
);

export default Landing;